import type { Article } from "@/mocks/portal";
import { categories } from "@/mocks/portal";
import { Link } from "react-router-dom";

const catName = (slug: string) => categories.find((c) => c.slug === slug)?.name ?? "推荐";

interface Props {
  article: Article;
  large?: boolean;
}

export default function ArticleCard({ article, large = false }: Props) {
  return (
    <article
      className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-100"
    >
      <Link
        to={`/article/${article.id}`}
        className={`relative block w-full overflow-hidden bg-background-200 ${large ? "aspect-[16/9]" : "aspect-[4/3]"}`}
      >
        <img
          src={article.image}
          alt={article.title}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-primary-700">
          {catName(article.category)}
        </span>
      </Link>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <Link to={`/article/${article.id}`} className="flex-1">
          <h3
            className={`font-heading font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 ${
              large ? "text-lg md:text-2xl" : "text-base md:text-lg"
            }`}
          >
            {article.title}
          </h3>
          <p className={`mt-2 text-foreground-600 ${large ? "line-clamp-3" : "line-clamp-2"} hidden sm:block text-sm`}>
            {article.summary}
          </p>
        </Link>
        <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
          <div className="flex items-center gap-2">
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
              <i className="ri-user-line text-xs" />
            </span>
            <span className="whitespace-nowrap">{article.author}</span>
          </div>
          <div className="flex items-center gap-3 whitespace-nowrap">
            <span>{article.date}</span>
            <span className="hidden sm:inline">{article.readTime}</span>
          </div>
        </div>
      </div>
    </article>
  );
}